import { setupChartJS } from './chart-js-setup';

setupChartJS();

export * from './highlight-point-plugin';
export * from './line-chart';
export * from './bar-chart';
export * from './doughnut-chart';
export * from './components';
